<div class="landing-page">

  <!-- Header -->
  <header class="landing-header">
    <div class="logo-wrap">
      <img src="assets/images/picaggo-logo.png" alt="Picaggo" class="logo"
        onerror="this.style.display='none'" />
      <span class="brand-name">Picaggo</span>
    </div>
    <span class="beta-badge">Demo</span>
  </header>

  <!-- Hero text -->
  <div class="hero-section">
    <h1 class="headline">
      Create Your<br>
      <span class="headline-accent">Event Album.</span>
    </h1>
    <p class="tagline">
      Build a personalised demo in seconds. See exactly what your guests will experience — gallery, guestbook and more.
    </p>
  </div>

  <!-- Form card -->
  <div class="form-card">
    <h2 class="form-title">Create Your Demo</h2>

    <div class="field-group">
      <label class="field-label" for="eventName">Event Name</label>
      <input
        id="eventName"
        type="text"
        class="field-input"
        placeholder="e.g. Summer Soirée 2025"
        [(ngModel)]="eventName"
        (keyup.enter)="preview()"
        maxlength="80"
        autocomplete="off"
      />
    </div>

    <div class="field-group">
      <label class="field-label" for="eventDate">Event Date</label>
      <input
        id="eventDate"
        type="date"
        class="field-input"
        [(ngModel)]="eventDate"
      />
    </div>

    <!-- Cover photo -->
    <div class="field-group">
      <label class="field-label">Cover Photo <span class="optional">optional</span></label>
      <input type="file" id="coverInput" accept="image/*"
        (change)="onCoverSelected($event)" class="file-input" />

      <!-- ── Adjust mode ── -->
      <div class="adjust-wrap" *ngIf="coverPreview && isAdjusting">
        <div class="adjust-frame"
          (mousedown)="onMouseDown($event)"
          (touchstart)="onTouchStart($event)">
          <img [src]="coverPreview"
               [style.object-position]="coverPositionStyle"
               class="adjust-img"
               draggable="false"
               alt="Cover" />
          <!-- grid overlay -->
          <div class="adjust-grid">
            <div class="grid-line gl-v1"></div>
            <div class="grid-line gl-v2"></div>
            <div class="grid-line gl-h1"></div>
            <div class="grid-line gl-h2"></div>
          </div>
          <div class="adjust-hint-bar">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="5 9 2 12 5 15"/><polyline points="19 9 22 12 19 15"/>
              <line x1="2" y1="12" x2="22" y2="12"/>
            </svg>
            Drag to reposition
          </div>
        </div>
        <div class="adjust-actions">
          <button class="adjust-remove-btn" (click)="removeCover()" type="button">Remove</button>
          <button class="adjust-done-btn" (click)="confirmAdjust()" type="button">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            Looks good
          </button>
        </div>
      </div>

      <!-- ── Normal preview (confirmed) ── -->
      <div class="cover-preview-wrap" *ngIf="coverPreview && !isAdjusting">
        <img [src]="coverPreview"
             [style.object-position]="coverPositionStyle"
             class="cover-preview-img" alt="Cover" />
        <div class="cover-preview-overlay">
          <span class="cover-check">✓ Cover added</span>
          <div class="cover-preview-btns">
            <button class="remove-btn" (click)="openAdjust()" type="button">Adjust</button>
            <button class="remove-btn" (click)="removeCover()" type="button">Remove</button>
          </div>
        </div>
      </div>

      <!-- ── Upload prompt ── -->
      <label for="coverInput" class="cover-upload-label" *ngIf="!coverPreview">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="3"/>
          <circle cx="8.5" cy="8.5" r="1.5"/>
          <polyline points="21,15 16,10 5,21"/>
        </svg>
        <span>Click to upload image</span>
      </label>
    </div>

    <button
      class="preview-btn"
      [disabled]="!eventName.trim() || isAdjusting || isNavigating"
      (click)="preview()"
    >
      {{ isNavigating ? 'Setting up…' : 'Build My Demo' }}
    </button>

    <p class="form-footer">Free · No sign-up · Ready in 10 seconds</p>
  </div>

</div>
